import React from 'react';
import image1 from '../../static/images/section3-jeunes/lecture-enfants-1200.jpg';
import trace1 from '../../static/images/effects/trace.svg';
import video3 from '../../static/images/section3-jeunes/dei_itv_mariama.png';
import video4 from '../../static/images/section3-jeunes/dei_itv_nick_arnaud.png';

export const Section3Jeunes = ({ setVideoModalOpen, setVideoModalSrc }) => {
  const openModal = (src) => () => {
    setVideoModalOpen(true);
    setVideoModalSrc(src);
  };
  return (
    <section id="section3-jeunes" className="pb-8 mb-0">
      <div className="container w-10/12 m-auto flex flex-col-reverse md:flex-row md:flex-wrap-reverse">
        <div className="p-4">

          <div className="flex flex-col md:flex-row justify-center items-center">
            <div className="w-full md:w-1/2">
              <h2 className="mb-8">Jeunes facilitateur·rices</h2>
              <p className="pr-0 md:pr-8 mb-4">
                Le projet a bénéficié de l’implication d’un groupe de jeunes formé·e·s en tant que facilitateur·rices. Ces jeunes, riches de leur expérience de migration, ont construit un lien privilégié avec les enfants et ont permis, avec le soutien d’artistes, la création d’outils de sensibilisation.
              </p>
              <p className="pr-0 md:pr-8 ">
                Première étape, la participation à l’une de nos formations pour
                devenir des jeunes facilitateur·rices autour des questions de VBG et
                d’animation auprès des enfants.
              </p>
            </div>
            <img src={image1} alt="" className="w-full md:w-1/2 mt-4 md:mt-0" id="image" />
          </div>
          <div className="w-full">
            <img src={trace1} className="m-auto h-16 mt-8 mb-4" />
          </div>
          <div className="flex flex-col md:flex-row justify-center items-center">
            <div className="flex flex-wrap video-container w-full md:w-1/2 mb-4 md:mb-0">
              <div className="video-content w-full md:w-1/2" onClick={openModal('https://dei-videos.if3.dev/dei_itv_nick_arnaud.mp4')}>
                <img src={video4} />
                <i className="far fa-play-circle" />
              </div>
              <div className="video-content w-full md:w-1/2" onClick={openModal('https://dei-videos.if3.dev/dei_itv_mariama.mp4')}>
                <img src={video3} />
                <i className="far fa-play-circle" />
              </div>
            </div>
            <p className="px-0 md:px-8 w-full md:w-1/2">
              Deuxième étape, les jeunes co-animent
              des ateliers pour sensibiliser des enfants migrant·e.s à la question
              des VBG et développer avec eux et l’aide d’un·e artiste les outils de
              sensibilisation. Pour leur implication et leur contribution
              inestimable au projet, nous tenons à les remercier chaleureusement.
            </p>
          </div>
        </div>

      </div>
    </section>
  );
};
